import { ref, watch, onMounted } from 'vue';

export function useTheme() {
  const isDark = ref(false);
  
  const initTheme = () => {
    const saved = localStorage.getItem('theme');
    if (saved) {
      isDark.value = saved === 'dark';
    } else {
      isDark.value = window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    applyTheme();
  };
  
  const applyTheme = () => {
    if (isDark.value) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };
  
  const toggleTheme = () => {
    isDark.value = !isDark.value;
    localStorage.setItem('theme', isDark.value ? 'dark' : 'light');
    applyTheme();
  };
  
  watch(isDark, applyTheme);
  
  onMounted(() => {
    initTheme();
  });
  
  return {
    isDark,
    toggleTheme
  };
}
